import { Cast } from '../../apiService';
import { Box, Text } from '../../styles';
import { SpacingProps } from '../../withStyleSystem';

const ContentCast = ({ cast, ...spacingProps }: { cast: (Cast | undefined)[] } & SpacingProps) => {
  return (
    <Box as="table" {...spacingProps}>
      <tbody>
        {cast.map((row, index) => row && <CastRow key={`${row.role}-${index}`} cast={row} />)}
      </tbody>
    </Box>
  );
};

const CastRow = ({ cast }: { cast: Cast }) => {
  const { role, artists } = cast;
  // const role = r.replace(' ', '‌');

  return (
    <Box as="tr">
      <Text as="td" variant="body2" color="weak" ml={2}>
        {/* {artists.length > 1 ? pluralize(role) : role}: */}
        {role} :
        <Box as="span" mx={1} />
      </Text>
      <Text as="td" variant="body2" weight="medium">
        {artists.join('، ')}
      </Text>
    </Box>
  );
};

// function pluralize(word: string) {
//   const ends = {
//     HE: 'ه',
//     REH: 'ره',
//   };

//   const suffixes = {
//     AN: 'ان',
//     HA: '‌ها',
//     GAN: 'گان',
//   };

//   if (word.endsWith(ends.REH)) return word + suffixes.HA;
//   if (word.endsWith(ends.HE)) return word.slice(0, -1) + suffixes.GAN;
//   return word + suffixes.AN;
// }

export default ContentCast;
